import React from "react";
import { VenetianMask } from "lucide-react";
import UserMenu from "./UserMenu";
import NotificationBell from "./NotificationBell";
import GlobalSearch from "./GlobalSearch";
import { getImpersonationState, stopImpersonation } from "../../utils/impersonation";

const TopBanner = () => {
  const { isImpersonating, impersonatedUser, realUser } = getImpersonationState();

  return (
    <header style={styles.wrap}>
      <div style={styles.left}>
        <div style={styles.brand}>
          <div style={styles.logoWrap}>
            <img src="/logo192.png" alt="Logo" style={styles.logoImg} />
          </div>
          <div>
            <h1 style={styles.title}>Stay Interview Platform</h1>
            <p style={styles.subtitle}>AI-powered employee insights</p>
          </div>
        </div>
      </div>

      <GlobalSearch />

   <div style={styles.right}>
  {isImpersonating && (
    <div style={styles.impersonationChip}>
      <VenetianMask size={14} />
      <span>
        Impersonating{" "}
        <strong>{impersonatedUser?.sip_name || impersonatedUser?.email}</strong>
        {realUser && (
          <span style={styles.impersonationRealUser}>
            {" "}(you are {realUser?.sip_name || realUser?.email})
          </span>
        )}
      </span>

      <button
        type="button"
        onClick={stopImpersonation}
        style={styles.stopImpersonationBtn}
      >
        Stop
      </button>
    </div>
  )}

  <NotificationBell />
  <UserMenu apiBaseUrl={process.env.REACT_APP_API_BASE_URL} isImpersonating={isImpersonating} />
</div>
    </header>
  );
};

/* ---------- styles ---------- */
const styles = {
  wrap: {
    position: "sticky",
    top: 0,
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 18px",
    background:
      "linear-gradient(180deg, rgba(10,15,32,0.78) 0%, rgba(10,15,32,0.66) 100%)",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    boxShadow: "0 4px 16px rgba(2,6,23,0.25)",
  },

  left: { display: "flex", alignItems: "center", gap: 12 },
  brand: { display: "flex", alignItems: "center", gap: 12 },

  logoWrap: {
    width: 36,
    height: 36,
    borderRadius: 10,
    overflow: "hidden",
    background:
      "radial-gradient(120% 120% at 0% 0%, #14b8a6 0%, #0891b2 45%, rgba(20,184,166,.2) 100%)",
    border: "1px solid rgba(255,255,255,0.15)",
    boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.06)",
    display: "grid",
    placeItems: "center",
  },
  logoImg: {
    width: 22,
    height: 22,
    filter: "drop-shadow(0 1px 2px rgba(0,0,0,.25))",
  },

  title: {
    margin: 0,
    fontSize: 16,
    fontWeight: 800,
    letterSpacing: ".02em",
    color: "#e5e7eb",
  },
  subtitle: {
    margin: 0,
    marginTop: 2,
    fontSize: 12,
    color: "rgba(229,231,235,.75)",
  },

  right: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  impersonationRealUser: {
    fontWeight: 600,
    opacity: 0.85,
  },
  impersonationChip: {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "7px 10px",
  borderRadius: 999,
  background: "rgba(245, 158, 11, 0.95)",
  color: "#111827",
  fontSize: 12.5,
  fontWeight: 800,
  boxShadow: "0 2px 10px rgba(245,158,11,.28)",
},

stopImpersonationBtn: {
  border: "none",
  background: "#111827",
  color: "#fff",
  borderRadius: 999,
  padding: "4px 9px",
  cursor: "pointer",
  fontSize: 12,
  fontWeight: 900,
},
};

export default TopBanner;
